import { Alert, Snackbar } from "@mui/material";
import { useState } from "react";

type SnackBarProps = {
    message: string;
    severity: "error" | "success" | "info" | "warning";
}

export default function SnackBar({ message, severity }: SnackBarProps) {
    const [open, setOpen] = useState(true);

    return (
        <Snackbar
            open={open}
            autoHideDuration={3000}
            onClose={() => setOpen(false)}
            anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        >
            <Alert
                onClose={() => setOpen(false)}
                severity={severity}
                sx={{
                width: "100%",
                "& .MuiAlert-message": { color: "#fff" },
                }}
            >
                {message}
            </Alert>
        </Snackbar>
    )
}